import { HeroProps } from 'src/components/Hero/types'
import { SHero } from 'src/rest/types/api/Components'
import { STheme } from 'src/rest/types/api/Theme'

import { ImageTransformer } from '../Transformers/ImageTransformer'
import { ButtonTransformer } from '../Transformers/ButtonTransormer'
import { getThemeColor } from '../Transformers/ThemeTransformer'
import { colors } from '../../theme'

export type UseHeroProps = {
  hero?: SHero
  theme?: STheme
  large?: boolean
}

const useHero = ({ hero, theme, large }: UseHeroProps): HeroProps => {
  // Strapi v4 wraps media as `{ data: { ... } }`; v5 returns it flat. Unwrap
  // once so downstream transformers can read the image either way.
  const desktopImage: any =
    (hero?.desktopImage as any)?.data ?? hero?.desktopImage
  const mobileImage: any = (hero?.mobileImage as any)?.data ?? hero?.mobileImage
  const desktopImageProps = ImageTransformer(
    desktopImage,
    large ? { desktop: '100vw, 100vw' } : { desktop: '100vw, 50vw' }
  )
  const mobileImageProps = ImageTransformer(
    mobileImage,
    large ? { desktop: '100vw, 100vw' } : { desktop: '100vw 50vw' }
  )
  return {
    title: hero?.title ?? '',
    richTextProps: hero?.description
      ? { html: hero?.description || '' }
      : undefined,
    // Only emit `pictureProps` when we have a valid desktop image. Passing
    // `imageProps: undefined` makes `<Picture>` return `null`, which in turn
    // leaves the surrounding `motion(Picture)` observer with a null DOM ref
    // and crashes framer-motion with "Invalid value used as weak map key".
    ...(desktopImageProps && {
      pictureProps: {
        imageProps: desktopImageProps,
        mobileImageProps,
      },
    }),
    color: getThemeColor(theme),
    ...(hero?.cta
      ? {
          actionButtonProps: ButtonTransformer({
            data: hero?.cta,
            theme: theme,
            forceColor: colors.blueLight,
          }),
        }
      : undefined),
    ...(hero?.keyStat || hero?.keyStatDescription
      ? {
          keyFigures: [hero?.keyStat || '', hero?.keyStatDescription || ''],
        }
      : undefined),
  }
}

export default useHero
